import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import { TCRBPlace } from '../@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
} from '../@types';

export type TCRBItem20P1 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem20P2 = {
    originOfBallast: string;
};

export type TCRBItem20P3 = {
    tanks: TCRBItem20Tank[];
};

export type TCRBItem20Tank = {
    selectedTank: TMARPOLTank;
    newQuantity: number;
    transferQuantity: number;
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem21 = {
    totalOperatedWaterVolume: number;
};

export type TCRBG1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBG;
        item20P1: TCRBItem20P1;
        item20P2: TCRBItem20P2;
        item20P3: TCRBItem20P3;
        item21: TCRBItem21;
    };

export type TCRBG = TCRBG1;

const CRBG_DEFAULTS: {
    G: TCRBG1;
} = {
    G: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item20P1: {
            placeOfBallast: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        item20P2: {
            originOfBallast: '',
        },
        item20P3: {
            tanks: [],
        },
        item21: {
            totalOperatedWaterVolume: 0,
        },
        recordCode: ECRBRecordCode.CRBG,
    },
};

export { CRBG_DEFAULTS };
